<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="12" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              depressed
              dark
              @click="(dialogAdd = true)"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              เพิ่ม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="dialogAdd" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false" style="overflow-x: hidden;">
                <v-card  style="overflow-x: hidden;">
              <v-form ref="form" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>ตั้งค่าระบบชำระเงิน</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click="(dialogAdd = false), clearData()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col style="text-align: center;">
                            <div style="display: flex;
                            justify-content: center;">
                            <v-radio-group
                                v-model="formAdd.payType"
                                row
                                >
                                <v-radio
                                    label="พร้อมเพย์"
                                    value="promptpay"
                                    @change="getPrompt()"
                                ></v-radio>
                                <v-radio
                                    label="นิติบุคล"
                                    value="bank"
                                ></v-radio>
                            </v-radio-group></div>
                        </v-col>
                    </v-row>
                    <v-row v-if="formAdd.payType === 'promptpay'">
                        <v-col>
                            <v-sheet
                                    class="mx-auto"
                                    elevation="8"
                                    max-width="800"
                                    v-if="formSelect.length > 0"
                                >
                                    <v-slide-group
                                    v-model="model"
                                    class="pa-4"
                                    show-arrows
                                    >
                                    <v-slide-item
                                        v-for="i in formSelect" :key="i"
                                        v-slot="{ active, toggle }"
                                    >
                                        <v-card
                                        :color="active ? 'primary' : 'grey lighten 1'"
                                        class="ma-4 rounded-lg hoverable "
                                        height="150"
                                        width="190"
                                        @click="toggle, select(i)"
                                        tile
                                        >
                                        <v-row
                                            class="fill-height"
                                            align="center"
                                            justify="center"
                                        >
                                        <v-col cols="12" style="padding: 15px 15px 0px;">
                                            <h3 class="text-center">ระบบชำระเงิน</h3>
                                        </v-col>
                                        <v-col cols="12" class="d-flex align-center justify-center" style="padding: 0 20px">
                                            <p class="account-name"> ชื่อบัญชี {{ i.promptPayName }}</p>
                                        </v-col>
                                        <v-col cols="12" class="d-flex align-center justify-center" style="padding: 0 20px;">
                                            <p class="text-center ">หมายเลข {{ i.promptPayID }}</p>
                                        </v-col>
                                        </v-row>
                                        </v-card>
                                    </v-slide-item>
                                    </v-slide-group>
                                </v-sheet>
                        </v-col>
                    </v-row>
                    <v-row v-if="formAdd.payType === 'promptpay'">
                        <v-col>
                            <v-text-field
                            v-model="formAdd.promtpayName"
                            label="ชื่อบัญชีพร้อมเพย์"
                            outlined
                            dense
                            clearable
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                            v-model="formAdd.promtpayNumber"
                            label="หมายเลขพร้อมเพย์ผู้รับเงิน"
                            outlined
                            dense
                            clearable
                            ></v-text-field>
                        </v-col>
                        <v-col class="d-flex" cols="12">
                          <v-select
                            v-model="formAdd.listPackageId"
                            :items="packages"
                            label="แพ็กเกจที่ต้องการเลือก"
                            dense
                            outlined
                            clearable
                            multiple
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </v-col>
                    </v-row>
                    <v-row v-if="formAdd.payType === 'promptpay'">
                        <v-col>
                            <v-btn block dark color="#1B437C" @click="submit()">บันทึก</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="formAdd.payType === 'bank'">
                        <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px 15px;justify-content: center; align-items: center;display: flex;"
                            >
                              <v-card
                                @click="chooseImage()"
                                class="image-input"
                                :style="{
                                  'background-image': `url(${formAdd.pictureUrlPreview})`,
                                  'background-size': 'contain',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat'
                                }"
                              >
                                <span
                                  v-if="formAdd.pictureUrlPreview === ''"
                                  class="placeholder"
                                  style="justify-content: center; align-items: center;display: flex;"
                                  >Choose an Image</span
                                >
                                <input
                                  style="display: none"
                                  class="file-input"
                                  ref="fileInputA"
                                  type="file"
                                  @input="onSelectFile"
                                />
                              </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                            v-model="formAdd.promtpayName"
                            label="ชื่อบัญชีพร้อมเพย์"
                            outlined
                            dense
                            clearable
                            ></v-text-field>
                            </v-col>
                            <v-col class="d-flex" cols="12">
                            <v-select
                              v-model="formAdd.listPackageId"
                              :items="packages"
                              label="แพ็กเกจที่ต้องการเลือก"
                              dense
                              outlined
                              clearable
                              multiple
                              item-text="name"
                              item-value="id"
                            ></v-select>
                          </v-col>
                            <v-col>
                            <v-btn block dark color="#1B437C" @click="submitBank()">บันทึก</v-btn>
                        </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
            </v-dialog>

            <v-dialog v-model="dialogEdit" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card>
              <v-form ref="form" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>ตั้งค่าระบบชำระเงิน</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click="(dialogEdit = false), clearData()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                        <v-col style="text-align: center;">
                            <div style="display: flex;
                            justify-content: center;">
                            <v-radio-group
                                v-model="formUpdate.payType"
                                row
                                >
                                <v-radio
                                    label="พร้อมเพย์"
                                    value="promptpay"
                                    disabled
                                    @change="getPrompt()"
                                ></v-radio>
                                <v-radio
                                    label="นิติบุคล"
                                    value="bank"
                                    disabled
                                ></v-radio>
                            </v-radio-group></div>

                        </v-col>
                    </v-row>
                    <v-row v-if="formUpdate.payType === 'promptpay'">
                        <v-col>
                            <v-text-field
                            v-model="formUpdate.promtpayName"
                            label="ชื่อบัญชีพร้อมเพย์"
                            outlined
                            dense
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                            v-model="formUpdate.promtpayNumber"
                            label="หมายเลขพร้อมเพย์ผู้รับเงิน"
                            outlined
                            dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="d-flex" cols="12">
                          <v-select
                            v-model="formUpdate.listPackageId"
                            :items="packages"
                            label="แพ็กเกจที่ต้องการเลือก"
                            dense
                            outlined
                            clearable
                            multiple
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </v-col>
                    </v-row>
                    <v-row v-if="formUpdate.payType === 'promptpay'">
                        <v-col>
                            <v-btn block dark color="#1B437C" @click="submitEdit()">บันทึก</v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="formUpdate.payType === 'bank'">
                        <v-col
                              cols="12"
                              xs="12"
                              sm="12"
                              md="12"
                              lg="12"
                              style="padding:0px 10px 15px;justify-content: center; align-items: center;display: flex;"
                            >
                              <v-card
                                @click="chooseImageUpdate()"
                                class="image-input"
                                :style="{
                                  'background-image': `url(${formUpdate.pictureUrlPreview})`,
                                  'background-size': 'contain',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat'
                                }"
                              >
                                <span
                                  v-if="formUpdate.pictureUrlPreview === ''"
                                  class="placeholder"
                                  style="justify-content: center; align-items: center;display: flex;"
                                  >Choose an Image</span
                                >
                                <input
                                  style="display: none"
                                  class="file-input"
                                  ref="fileInputUpdate"
                                  type="file"
                                  @input="onSelectFileUpdate"
                                />
                              </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field
                            v-model="formUpdate.promtpayName"
                            label="ชื่อบัญชีพร้อมเพย์"
                            outlined
                            dense
                            ></v-text-field>
                            </v-col>
                            <v-col class="d-flex" cols="12">
                              <v-select
                                v-model="formUpdate.listPackageId"
                                :items="packages"
                                label="แพ็กเกจที่ต้องการเลือก"
                                dense
                                outlined
                                clearable
                                multiple
                                item-text="name"
                                item-value="id"
                              ></v-select>
                            </v-col>
                            <v-col>
                            <v-btn block dark color="#1B437C" @click="submitBankEdit()">บันทึก</v-btn>
                        </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card>
                <v-container>
                    <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="ชื่อบัญชี"
                        outlined
                        dense
                        v-model="formUpdate.promtpayName"
                        readonly
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  dark
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
                </v-container>

            </v-card>
          </v-dialog>

            <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.point`]="{ item }">
                    {{ formatNumber(item.point) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.priviledge`]="{ item }">
                    <nl2br tag="p" :text="item.priviledge" />
                  </template>
                  <template v-slot:[`item.color`]="{ item }">
                    <v-card
                      class="mx-auto card-index div_color"
                      width="120"
                      height="70"
                      color="#E0E0E0"
                    >
                      <div
                        :style="'background-color:' + item.color"
                        class="rotate"
                      ></div>
                    </v-card>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          id="v-step-2"
                          x-small
                          @click.stop="getDataItem(item), dialogEdit = true"
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          x-small
                          @click.stop="getDataById(item, 'delete')"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>

        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api

export default {
  components: {
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      model: null,
      session: this.$session.getAll(),
      dialogAdd: false,
      dialogEdit: false,
      validAdd: true,
      validUpdate: true,
      dialogDelete: false,
      dataItem: [],
      dataPackage: [],
      path: '/package/', // Path Model get  Package
      formAdd: {
        payType: 'promptpay',
        promtpayName: '',
        promtpayNumber: '',
        masBranchID: null,
        payImage: '',
        pictureUrlPreview: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        listPackageId: ''
      },
      formUpdate: {
        Id: '',
        payType: '',
        promtpayName: '',
        promtpayNumber: '',
        masBranchID: null,
        payImage: '',
        pictureUrlPreview: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId,
        listPackageId: ''
      },
      formSelect: [],
      packegeIdSeted: [],
      filesAdd: null,
      filesUpdate: null,
      columns: [
        { text: 'ประเภท', value: 'payType' },
        { text: 'ชื่อบัญชีพร้อมเพย์', value: 'promtpayName' },
        { text: 'หมายเลข', value: 'promtpayNumber' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ]
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    this.getDataPackage()
    this.getData()
    this.getPrompt()
    this.mergePackages()
    console.log('ffdfdff', this.dataItem)
  },
  methods: {
    async getData () {
      await axios
        .get(this.DNS_IP + '/Payment/get?shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          this.dataItem = res.data
          console.log('dataItem', this.dataItem)
          this.dataItem.map((item) => {
            if (item.listPackageId && item.listPackageId !== '') {
              console.log('aaaaaaa')
              const data = item.listPackageId.split(',')
              data.forEach(element => {
                this.packegeIdSeted.push(element)
              })
            }
          })
          // กรองแพ็กเกจที่มี id ตรงกับค่าที่อยู่ใน `packegeIdSeted` ออกไป
          // this.packages = this.packages.filter(item => {
          //   return !this.packegeIdSeted.some(item2 => item.id.toString() === item2)
          // })
        })
      console.log('this.packagesss', this.packages)
      console.log('this.packegeIdSeted', this.packegeIdSeted)
    },
    async getDataItem (item) {
      try {
        console.log('item', item)
        await axios.get(this.DNS_IP + '/Payment/getID?Id=' + item.Id)
          .then(res => {
            console.log('resData', res.data)
            console.log('formUpdateBefor', this.formUpdate)
            // อัปเดตข้อมูลจาก API ไปที่ formUpdate
            this.formUpdate.payType = res.data.payType
            this.formUpdate.promtpayName = res.data.promtpayName
            this.formUpdate.promtpayNumber = res.data.promtpayNumber
            this.formUpdate.masBranchID = res.data.masBranchID
            this.formUpdate.payImage = res.data.payImage
            this.formUpdate.pictureUrlPreview = res.data.payImage
            this.formUpdate.CREATE_USER = res.data.CREATE_USER
            this.formUpdate.LAST_USER = res.data.LAST_USER
            this.formUpdate.shopId = res.data.shopId
            this.formUpdate.Id = item.Id
            this.formUpdate.listPackageId = item.listPackageId === '' || item.listPackageId === null ? '' : item.listPackageId.split(',').map(Number)
          })
        console.log('formUpdateAfter', this.formUpdate)
        console.log('formUpdate.packege2 listPackageId', item.listPackageId)
      } catch (error) {
        console.log('error', error)
      }
    },
    getPrompt () {
      this.formSelect = []
      this.formAdd.payType = 'promptpay'
      axios
        .get('https://api-belinked.betaskthai.tech/flow/get?shopId=' + this.$session.getAll().data.shopId)
        .then(res => {
          res.data.map(el => {
            this.formSelect.push(el)
          })
          console.log(this.formSelect)
        })
    },
    select (i) {
      console.log('i', i)
      this.formAdd.promtpayName = i.promptPayName
      this.formAdd.promtpayNumber = i.promptPayID
    },
    submit () {
      this.$swal({
        title: 'ต้องการเพิ่มข้อมูลการชำระเงินใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
        //   this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.listPackageId = this.formAdd.listPackageId.toString()
          delete this.formAdd['pictureUrlPreview']
          // console.log('formADD', this.formAdd)
          axios
            .post(
              this.DNS_IP + '/Payment/add',
              this.formAdd
            )
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.clear()
              this.getData()
              this.dialogAdd = false
            //   this.loadingAdd = false
            })
        })
    },
    chooseImage () {
      this.$refs.fileInputA.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInputA
      this.filesAdd = input.files
      if (this.filesAdd) {
        console.log('เข้า')
        this.formAdd.pictureUrlPreview = URL.createObjectURL(
          this.filesAdd[0]
        )
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      this.$forceUpdate()
      console.log('kkkk', this.formAdd.pictureUrlPreview)
    },
    chooseImageUpdate () {
      this.$refs.fileInputUpdate.click()
    },
    onSelectFileUpdate () {
      const input = this.$refs.fileInputUpdate
      this.filesUpdate = input.files
      if (this.filesUpdate) {
        console.log('เข้า')
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate[0]
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      this.$forceUpdate()
      console.log('kkkk', this.formUpdate.pictureUrlPreview)
    },
    submitBank () {
      this.$swal({
        title: 'ต้องการเพิ่มข้อมูลการชำระเงินใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.listPackageId = this.formAdd.listPackageId.toString()

          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd[0])
          console.log('params', params)
          // console.log('this.formAddPostApi', this.formAdd)
          await axios
            .post(this.DNS_IP + `/file/upload/package`, params)
            .then(function (response) {
              _this.formAdd.payImage = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          axios
            .post(
              this.DNS_IP + '/Payment/add',
              this.formAdd
            )
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.clear()
              this.getData()
              this.dialogAdd = false
            //   this.loadingAdd = false
            })
        })
    },
    submitEdit () {
      this.$swal({
        title: 'ต้องการแก้ไขข้อมูลการชำระเงินใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.formUpdate.LAST_USER = this.session.data.userName
          delete this.formUpdate['pictureUrlPreview']
          this.formUpdate.listPackageId = this.formUpdate.listPackageId.join(',')
          await axios
            .post(
              this.DNS_IP + '/Payment/edit/' + this.formUpdate.Id,
              this.formUpdate
            )
            .then(async response => {
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)
              this.dialogEdit = false
              await this.getData()
              this.clearUpdate()
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
            //   this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
    },
    submitBankEdit () {
      this.$swal({
        title: 'ต้องการแก้ไขข้อมูลการชำระเงินใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.formUpdate.LAST_USER = this.session.data.userName
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate[0])
            await axios
              .post(this.DNS_IP + `/file/upload/package`, params)
              .then(function (response) {
                _this.formUpdate.payImage = response.data
                console.log('url Pic', response.data)
              })
          }
          this.formUpdate.listPackageId = this.formUpdate.listPackageId.toString()
          delete this.formUpdate['pictureUrlPreview']
          await axios
            .post(
              this.DNS_IP + '/Payment/edit/' + this.formUpdate.Id,
              this.formUpdate
            )
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.clearUpdate()
              this.getData()
              this.dialogEdit = false
            })
        })
    },
    clear () {
      this.formAdd.payType = 'promptpay'
      this.formAdd.promtpayName = ''
      this.formAdd.promtpayNumber = ''
      this.formAdd.masBranchID = null
      this.formAdd.payImage = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
    },
    clearUpdate () {
      this.formUpdate.payType = ''
      this.formUpdate.promtpayName = ''
      this.formUpdate.promtpayNumber = ''
      this.formUpdate.masBranchID = null
      this.formUpdate.payImage = ''
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.formUpdate.shopId = this.$session.getAll().data.shopId
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.Id)
      this.dataReady = false
      await this.deleteDataGlobal(
        this.DNS_IP,
        /Payment/,
        this.formUpdate.Id,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async getDataById (item, type) {
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        '/Payment/',
        'Id',
        item.Id
      )
      //   this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
      if (type === 'edit') {
        this.dialogEdit = true
        this.validate('UPDATE')
      } else if (type === 'delete') {
        this.dialogDelete = true
      }
    },
    getDataPackage () {
      console.log('dataItem', this.dataItem)
      let month = this.dataItem
      this.dataItem = []

      // สร้างตัวแปรใหม่เพื่อเก็บแพ็กเกจในรูปแบบ { name: packageName, id: packageId }
      this.packages = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        // ฟอร์แมต packageExpridate
        if (d.packageExpri !== '') {
          if (d.packageExpri === '12') {
            d.packageExpridate = '1 ปี'
          } else {
            d.packageExpridate = d.packageExpri + ' เดือน'
          }
        } else {
          d.packageExpridate = ''
        }
        // เพิ่ม packageName และ packageId ลงในออบเจ็กต์ { name, id }
        if (d.packageName && d.packageId) {
          this.packages.push({ name: d.packageName, id: d.packageId })
        }
        if (this.dataItem.length > 0) {
          this.dataItem.push(d) // เพิ่มข้อมูลกลับเข้า dataItem
        }
      }
    }
  }
}
</script>
<style scoped>
.image-input {
  display: block;
  width: 200px;
  height: 350px;
  /* min-width: 300px;
  min-height: 300px; */
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.account-name {
  font-size: 14px;
    word-wrap: break-word; /* ตัดบรรทัดเมื่อข้อความยาวเกิน */
    white-space: normal; /* ให้ข้อความขึ้นบรรทัดใหม่ */
    text-align: center; /* จัดข้อความให้อยู่ตรงกลาง */
  }

</style>



// WEBPACK FOOTER //
// src/components/System/pay.vue